/** Related blog cards shown on /multi-channel-fulfillment-services */
export type MultiChannelRelatedBlogCard = {
  slug: string;
  title: string;
  description: string;
  image: string;
  date: string;
  tags: string[];
};

export const MULTI_CHANNEL_RELATED_BLOG_CARDS: MultiChannelRelatedBlogCard[] = [
  {
    slug: 'how-to-choose-multi-channel-fulfilment-partner-uk-2026',
    title: 'How to Choose a Multi-Channel Fulfilment Partner UK (2026 Guide)',
    description:
      'Vetting questions, pricing transparency and red flags for multi-channel 3PL UK small business sellers.',
    image: '/Images/smart-ecommerce-fulfillment-warehouse-uk-amazon-shopify-tiktok.webp',
    date: 'June 2026',
    tags: ['Multi-Channel', '3PL', 'UK Fulfilment'],
  },
  {
    slug: 'amazon-shopify-ebay-tiktok-one-3pl-uk',
    title: 'Amazon, Shopify, eBay & TikTok: Can One 3PL Handle All Your Channels?',
    description:
      'How to outsource multi-channel fulfilment UK with one stock pool, routing rules and synced tracking.',
    image: '/ "blogdataimages/" + $args[0].Groups[1].Value.ToLower() /ticktokimage.webp',
    date: 'June 2026',
    tags: ['Amazon', 'Shopify', 'TikTok Shop'],
  },
  {
    slug: 'how-to-outsource-ecommerce-fulfilment',
    title: 'How to Outsource Ecommerce Fulfilment',
    description:
      'Learn how to outsource ecommerce fulfilment with the right 3PL, systems and SLAs to improve accuracy, speed and scale.',
    image: 'https://afocirmbqdxnkyescnev.supabase.co/storage/v1/object/public/featured-images/76955a91-5da6-440f-ac37-6b58b7962ef2/b9375684-dd0d-40be-97a8-1fb7eb2fdcb4.webp',
    date: 'June 2026',
    tags: ['3PL', 'Outsourcing', 'UK Fulfilment'],
  },
  {
    slug: 'sfp-vs-fba-2026',
    title: 'SFP vs FBA in 2026 (full comparison)',
    description:
      'Compare Seller Fulfilled Prime and FBA when planning your multi-channel fulfilment strategy.',
    image: '/ "blogdataimages/" + $args[0].Groups[1].Value.ToLower() /img1.jpg',
    date: 'April 2026',
    tags: ['Amazon SFP', 'FBA', 'Strategy'],
  },
];
